<template>

    <div>
        <strong>
            {{ productName }}
        </strong>

        <div v-if="packageDescription">
            {{ packageDescription }}
        </div>

        <div v-if="imageURLs.length">
            <b-img v-for="image of imageURLs" :key="image" :src="image" fluid thumbnail />
        </div>
    </div>

</template>

<script lang="ts">
import { CompoundDrug } from '@/models/Drug/CompoundDrug';
import { Drug } from '@/models/Drug/Drug';
import { DrugProduct, DrugSource } from '@/models/Drug/DrugProduct';
import { NonGSDDDrug } from '@/models/Drug/NonGSDDDrug';
import { getDrugImageUrls } from '@/util/DrugImage';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';
import Axios from 'axios';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: "DrugInfoComponent",
    components: {

    },
})
export default class DrugInfoComponent extends Vue {

    @Prop() protected drug!: DrugProduct;

    protected imageURLs: string[] = [];
    protected drugDetails: DrugProduct | null = null;
    protected isLoading = false;

    mounted() {
        this.fetchDrug();
    }

    @Watch("drug")
    onDrugChange() {
        this.fetchDrug();
    }

    fetchDrug() {
        this.drugDetails = null;

        if (!this.drug.drugId) {
            return;
        }

        this.isLoading = true;

        Axios.get(`/Drug/${this.drug.drugId}`, { params: { drugSource: this.drug.source, getCategories: true, getVendors: true, fullDetail: true } })
            .then(response => {
                switch (response.data.source) {
                    case DrugSource.GsddFederal:
                        this.drugDetails = new Drug(response.data.drugId, response.data);
                        break;
                    case DrugSource.NonGsddProduct:
                        this.drugDetails = new NonGSDDDrug(response.data.drugId, response.data);
                        break;
                    case DrugSource.CompoundProduct:
                        this.drugDetails = new CompoundDrug(response.data.drugId, response.data);
                        break;
                }

                this.imageURLs = getDrugImageUrls(this.drug.drugId, this.drug.source);
            })
            .catch(error => {
                console.error('Problem while getting drug details.', { error, response: error?.response });
                this.$notification(NotificationOptions.error(error));
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    get productName() {
        if ((this.drug as Drug).productNameLong)
            return (this.drug as Drug).productNameLong;
        return this.drug.productNameShort;
    }

    get packageDescription() {
        if ((this.drugDetails as Drug)?.packageDescription)
            return (this.drugDetails as Drug).packageDescription;
        return null;
    }
}

</script>